module.exports = __webpack_public_path__ + "static/media/call-center-logo.c7507ced.webp";